import { type FC, type SVGProps } from 'react';

import CsvFileIcon from '@/assets/svg/ui-elements/csv-file.svg';
import PdfFileIcon from '@/assets/svg/ui-elements/file-pdf-red.svg';
import GenericFileIcon from '@/assets/svg/ui-elements/file-type.svg';

import { StyledFileIconWrapper } from './FileUpload.styled';

type FileIconComponent = FC<SVGProps<SVGSVGElement>>;

const SOLID_EXTENSION_ICONS: Record<string, FileIconComponent> = {
  csv: CsvFileIcon,
  pdf: PdfFileIcon,
};

const SOLID_CONTENT_TYPE_ICONS: Record<string, FileIconComponent> = {
  'application/pdf': PdfFileIcon,
  'text/csv': CsvFileIcon,
};

export const resolveFileIcon = (fileName: string, contentType?: string): FileIconComponent => {
  const [name, extension] = [fileName, fileName.split('.').pop()?.toLowerCase()];
  const byExtension =
    extension && extension !== name.toLowerCase() && SOLID_EXTENSION_ICONS[extension];
  if (byExtension) return byExtension;

  const type = contentType?.split(';')[0].trim().toLowerCase();
  return (type && SOLID_CONTENT_TYPE_ICONS[type]) || GenericFileIcon;
};

export const FileTypeIcon: FC<{ fileName: string; contentType?: string }> = ({
  fileName,
  contentType,
}) => {
  const Icon = resolveFileIcon(fileName, contentType);

  return (
    <StyledFileIconWrapper>
      <Icon />
    </StyledFileIconWrapper>
  );
};
